import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Clock, Loader2 } from "lucide-react";

export function ScheduleDialog({ open, onOpenChange, saving, schedule, setSchedule, onSave }) {
  const handleSave = () => {
    onSave(schedule, () => onOpenChange(false));
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Clock className="w-5 h-5 text-amber-600" />
            Configurar Agendamento
          </DialogTitle>
          <DialogDescription>
            Configure posts automáticos diários para suas redes sociais
          </DialogDescription>
        </DialogHeader>
        {schedule && (
          <div className="space-y-4 py-4">
            <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
              <div>
                <p className="font-medium text-sm">Ativar Agendamento</p>
                <p className="text-xs text-muted-foreground">Posts serão criados automaticamente</p>
              </div>
              <Switch
                checked={schedule.enabled}
                onCheckedChange={v => setSchedule(prev => ({ ...prev, enabled: v }))}
              />
            </div>
            {schedule.enabled && (
              <>
                <div>
                  <label className="text-xs font-medium text-muted-foreground">Horário do Post no Feed</label>
                  <Input
                    type="time"
                    value={schedule.post_time}
                    onChange={e => setSchedule(prev => ({ ...prev, post_time: e.target.value }))}
                  />
                </div>
                <div>
                  <label className="text-xs font-medium text-muted-foreground">Estilo de Conteúdo</label>
                  <Select
                    value={schedule.content_style}
                    onValueChange={v => setSchedule(prev => ({ ...prev, content_style: v }))}
                  >
                    <SelectTrigger><SelectValue /></SelectTrigger>
                    <SelectContent>
                      <SelectItem value="promotional">Promocional (ofertas, novidades)</SelectItem>
                      <SelectItem value="educational">Educativo (dicas, curiosidades)</SelectItem>
                      <SelectItem value="engagement">Engajamento (perguntas, enquetes)</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div>
                  <label className="text-xs font-medium text-muted-foreground">
                    Informações do Restaurante (para IA gerar conteúdo)
                  </label>
                  <Textarea
                    value={schedule.restaurant_info || ""}
                    onChange={e => setSchedule(prev => ({ ...prev, restaurant_info: e.target.value }))}
                    placeholder="Ex: Restaurante japonês em Córdoba, especialidade em sushi premium, ambiente acolhedor..."
                    rows={3}
                  />
                </div>
              </>
            )}
          </div>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button onClick={handleSave} disabled={saving} className="bg-amber-600 hover:bg-amber-700">
            {saving && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
            Salvar Configuração
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
